import api from './api';
import ErrorService from './errorService';


export const communeService = {

  getCommunesByProvince: async (idProvidence) => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/Districts/district/${idProvidence}`));
          //const response = await withTimeout(api.get(`/Districts/district/56`));
          return response.data;
      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener:', error);
          throw error;
        }
      },


  getAllCommunes: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get(`/Districts`));
      //const response = await withTimeout(api.get(`/Districts/district/56`));
      return response.data;
  
    } catch (error) {
      ErrorService.handleApiError('Error al obtener:', error);
      throw error;
    }
  },


};